import useSound from "use-sound";
// @ts-ignore
import soundTrack from "../assets/sounds/soundtrack.mp3";
import {useEffect} from "react";

export const usePlayMainSound = ({sound}: {sound: boolean}) => {
    // const [play, { stop, sound: soundObject }] = useSound(soundTrack, { volume: 0.7 });
    //
    // useEffect(() => {
    //     if (sound && soundObject) {
    //         soundObject.loop(true);
    //         play();
    //     } else {
    //         stop();
    //     }
    //
    //     return () => {
    //         stop();
    //     };
    // }, [sound, play, stop, soundObject]);
    //
    // useEffect(() => {
    //     const handleVisibilityChange = () => {
    //         if (document.hidden) {
    //             stop();
    //         } else if (sound) {
    //             play();
    //         }
    //     };
    //
    //     document.addEventListener('visibilitychange', handleVisibilityChange);
    //
    //     return () => {
    //         document.removeEventListener('visibilitychange', handleVisibilityChange);
    //     };
    // }, [sound, play, stop]);

    return {
        play: () => {},
        stop: () => {},
    }
}